<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <div v-if="isMenu">
      <NavMenu ref="child2Container"></NavMenu>
    </div>
    <router-view />
  </div>
</template>
<script>
import NavMenu from "./components/common/NavMenu.vue";

export default {
  name: "App",
  components: {
    NavMenu
  },
  data() {
    return {
      NotifyData: [],
      NotifyKey: 0,
      timer: null,
      isMenu:false
    };
  },
  created: function() {
    // this.signalr.off('UserNotice')
    // this.signalr.on('UserNotice', res => {
    //   //可以做相关业务逻辑
    //   console.log('signalr 来了')
    // })
  },
  mounted() {
    //滑动窗体 消息通知
    this.initSignalR();
  },

  methods: {
    initSignalR() {
      this.signalr.start().then(() => {
        console.log("signalr连接");
      });

      //判断是否成功
      // this.signalr.on('Success',(res)=>{
      //   //可以做相关业务逻辑
      //   console.log(res)
      //   console.log('signalr 来了1111111111111111');
      // })

      //回推 消息
      this.signalr.on("UserNotice", (msgType, msgTitle, msgContent) => {
        //可以做相关业务逻辑
        // console.log(msgType)
        // console.log(msgTitle)
        // console.log(msgContent)
        // console.log('signalr 来了1111111111111111')

        this.SlidingWindow(msgType, msgTitle, msgContent);
      });
    },
    onLoadGeneral(act) {
      this.$refs.child2Container.onloadPermissions(act);
      var UserName = localStorage.getItem("UserName");
      var DepartmentName = localStorage.getItem("DepartmentName");
      document.getElementById("txtUser").innerText =
        "当前用户：" + UserName + "（" + DepartmentName + "）";
    },
    RequestFailed(err) {
      console.log(err.response);
      let $this = this;
      if (err.response.data["ResponseCode"] == 401) {
        localStorage.setItem("Token", "");
        localStorage.setItem("UserName", "");
        localStorage.setItem("DepartmentName", "");

        const url = "#/Login/Login"; //登录页
        window.location.href = url;
        return false;
      } else if (err.response.data["ResponseCode"] == 403) {
        $this.$message.error("您登陆的账号没有相关的操作权限");
        return false;
      } else {
        // console.log(err);
        $this.$message.error(
          "操作异常：" + err.status + "," + err.statusText + ",请联系管理员！"
        );
        return false;
      }
    },
    // 滑动窗体 消息通知
    SlidingWindow(msgType, msgTitle, msgContent) {
      //console.log(this.NotifyData['Before'])
      // if (this.NotifyData['Before'] != undefined) {
      //   this.NotifyData['Before'].close()
      //   delete this.NotifyData['Before']
      //   //console.log('关闭通知')
      // }

      var txtTiele = "【" + msgType + "】";
      var ContentArr = msgContent.split(";");
      var msgHtml = "";
      msgHtml += '<div class="NotifyContent"><div>' + msgTitle + "</div>";
      msgHtml += "<div>";
      msgHtml += "<table>";
      for (let item of ContentArr) {
        msgHtml += "<tr>";
        msgHtml += '<td class="leftCol">' + item.split(":")[0] + "：</td>";
        msgHtml += '<td class="rightCol">' + item.split(":")[1] + "</td>";
        msgHtml += "</tr>";
      }
      msgHtml += "</table>";
      msgHtml += "</div>";
      msgHtml += "</div>";

      const notify = this.$notify({
        title: txtTiele,
        dangerouslyUseHTMLString: true,
        message: msgHtml,
        position: "bottom-right",
        duration: 1000 * 10,
        customClass: "NotifyCustomsDeclaration"
      });
      // this.NotifyData['Before'] = notify
      // console.log(this.NotifyData['Before'])
    }
  },
  watch: {
    $route(to, from) {
      let ThisPage = to.path
      let isMenu = this.$route.meta.isMenu
      if (ThisPage.indexOf('Demonstration') === -1 && ThisPage.indexOf('Error') === -1 && isMenu != false) {
        this.isMenu = true
      }
    }
  }
};

window.onbeforeunload = function(e) {
  console.log("关闭页面");
  //return "关闭页面"
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  margin-top: 0px;
  min-width: 1100px;
  font-size: 11px;
}

a:hover {
  text-decoration: inherit;
  cursor: pointer;
}
.el-cl {
  clear: both;
}
/*主题色修改 start*/
/*.el-button--primary{*/
/*  background: #FF9900;*/
/*  border-color: #FF9900;*/
/*}*/
/*.el-button--primary:hover{*/
/*  background: #FF6600;*/
/*  border-color: #FF6600;*/
/*}*/

/*.el-badge__content--primary{*/
/*  background: #F00;*/
/*}*/
/*主题色修改 end*/

/*特别提示 *红色*/
.el-SpecialNote {
  color: #f00;
}

/*滑动窗体 消息通知*/
.txtNotifyUnderline {
  text-decoration: underline;
  cursor: pointer;
}

.txtNotifyUnderline:hover {
  text-decoration: inherit;
  cursor: pointer;
}

.NotifyCustomsDeclaration,
.NotifySystem {
  width: 300px;
  height: 200px;
  bottom: 16px !important;
}

.NotifyCustomsDeclaration .el-notification__title {
  color: #008000;
}

.NotifySystem .el-notification__title {
  color: #ff0000;
}

.NotifyContent {
  height: 150px;
  overflow-y: auto;
}

.NotifyContent::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: #eee;
}

.NotifyContent::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background: #666;
}

.NotifyContent table {
  width: 100%;
  word-break: break-all;
}

.NotifyContent table .leftCol {
  width: 100px;
}

.NotifyContent table .rightCol {
  width: calc(100% - 100px);
}

/*单票委托 上传 宽高百分百*/
.upload-demo {
  width: 100% !important;
  height: 100% !important;
}

.el-upload {
  width: 100% !important;
  height: 100% !important;
}

.el-upload-dragger {
  width: 100% !important;
  height: 100% !important;
  border-radius: 10px !important;
  border: none !important;
}

/*descriptions label名称 居中显示*/
.el-label-redraw-c {
  text-align: center !important;
}

/*报关控制台 出口报关*/
/*descriptions 3列*/
.ymt3cLabelStyle {
  width: 15%;
}

.ymt3cContentStyle {
  width: 18.3%;
}

/*页面title标题样式*/
.divHeadline {
  position: relative;
  width: 242px;
  height: 36px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ff9900;
}

.txtMenu {
  position: absolute;
  left: 0px;
  bottom: -2px;
  font-size: 24px;
  font-weight: 700;
  color: #ff9900;
}

.txtChildMmenu {
  position: absolute;
  right: 0px;
  bottom: -2px;
  font-size: 18px;
  font-weight: 700;
  color: #ff9900;
}

.el-menu.el-menu--horizontal {
  border-bottom: solid 0px #e6e6e6 !important;
}

.el-button--warning {
  color: #fff;
  background-color: #f90 !important;
  border-color: #f90 !important;
}
.el-button--warning:disabled {
  color: #fff;
  background-color: #ccc !important;
  border-color: #ccc !important;
  cursor: not-allowed;
  pointer-events: auto;
}
.is-disabled {
  cursor: not-allowed !important;
}
#btnRefresh {
  padding: 0px;
  border: none;
  position: relative;
  top: 6px;
}
#btnRefresh i {
  font-size: 22px;
  font-weight: bold;
  color: #000;
}
#btnRefresh:disabled i {
  font-size: 22px;
  font-weight: bold;
  color: #ccc;
}

.el-tooltip {
  width: 100% !important;
}

.tooltip {
  overflow: hidden;
  text-overflow: ellipsis;
}

/*权限管理*/
/*descriptions 2列*/
.ymt2cLabelStyle {
  width: 20%;
}

.ymt2cContentStyle {
  width: 30%;
}

/*个人中心*/
.el-col-5 {
  width: 20% !important;
}

/*数据中心-下载配置*/
.fieldset {
  border: 1px solid #ccc;
  border-radius: 10px;
}

.dragBox {
  width: calc(100% - 20px);
  height: 450px;
  padding: 10px;
  font-size: 14px;
  overflow-y: auto;
}

.drag_ele {
  width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  height: 21px;
  font-size: 16px;
  margin-bottom: 5px;
  border: 1px dashed #ccc;
  border-radius: 5px;
  padding: 2px 25px 2px 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  position: relative;
}

.drag_ele i {
  position: absolute;
  right: 2px;
  top: 3px;
  background: #fff;
  font-weight: bold;
  color: #f00;
  cursor: pointer;
  font-size: 20px;
}

.drag_ele:hover {
  cursor: move;
}

.dragOverTips {
  pointer-events: none;
  user-select: none;
  text-align: center;
  line-height: 70px;
}

.legendStyle {
  font-size: 20px;
  color: #33435c;
  margin-left: 20px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/App.vue